import { useMemo } from 'react'
import { BaseTable } from 'Features/Table/BaseTable.view'
import { ExtendedGridColDef } from 'Features/Table/BulkUpdateModal'
import {
  SheduleTableProps,
  SchedulerResourceAndInputRowType,
} from './Scheduler.types'
import { Box } from '@mui/material'
const dataConfig = {
  required: ['inputProductCode', 'resource', 'runRate', 'workStationCode'],
  optional: ['inputProductName'],
}

export const SchedulerResourceAndInputTable = ({
  data,
  isLoading,
  updateTableData,
  uploadScheduleData,
  isUploading,
  isSaving,
  updateRowsStatus,
  predicate,
  deleteTableData,
  isDeleting,
}: SheduleTableProps<SchedulerResourceAndInputRowType>) => {
  // Handle data updates for BaseTable
  const handleDataUpdate = (
    changedRows: Record<number, SchedulerResourceAndInputRowType>
  ) => {
    updateTableData(changedRows)
  }
  //Example data:
  //   {
  //     "id": 0,
  //     "inputProductCode": "901637904",
  //     "resource": "people",
  //     "runRate": "3"
  // }
  const columns: ExtendedGridColDef[] = useMemo(
    () => [
      {
        field: 'inputProductCode',
        headerName: 'Input Product Code',
        type: 'string',
        flex: 1,
      },
      {
        field: 'inputProductName',
        headerName: 'Input Product Description',
        type: 'string',
        flex: 1,
      },
      {
        field: 'resource',
        headerName: 'Resource Constraint Name',
        type: 'string',
        flex: 1,
        editable: true,
      },
      {
        field: 'runRate',
        headerName: 'Run Rate',
        flex: 1,
        editable: true,
        type: 'number',
      },
      {
        field: 'workStationCode',
        headerName: 'Work Station Code',
        type: 'string',
        flex: 1,
      },
    ],
    [data]
  )

  return (
    <Box>
      <BaseTable
        data={data ?? []}
        columns={columns}
        isLoading={isLoading}
        updateTableData={handleDataUpdate}
        uploadData={uploadScheduleData}
        isUploading={isUploading}
        isSaving={isSaving}
        checkBoxSelection={true}
        showTableToolBar={true}
        downloadFileName="SchedulerResourceAndInput"
        onDeleteRows={deleteTableData}
        isDeleting={isDeleting}
        multiStageUpload={{
          uploadFile: uploadScheduleData,
          isUploading: isUploading,
          columns: columns,
          updateRowsStatus: updateRowsStatus,
          originalData: data,
          predicate: predicate,
          dataConfig: {
            required: [
              'inputProductCode',
              'resource',
              'runRate',
              'workStationCode',
            ],
            optional: ['inputProductName'],
          },
        }}
        initialState={{
          pagination: { paginationModel: { pageSize: 100 } },
        }}
        sx={{
          maxWidth: 'calc(100vw - 70px)',
          '& .MuiDataGrid-cell--editable': {
            backgroundColor: '#CBD5E1',
          },
          '& .MuiBox-root': {
            padding: '0px !important',
          },
        }}
      />
    </Box>
  )
}
